import React from 'react';
import { Segment } from 'semantic-ui-react';
import StatCard from "./StatCard";

const GameScore = props => (
    <Segment raised secondary textAlign="center">
        <StatCard color='green' icon='checkmark' text='Correct' count={props.CorrectCount} />
        <StatCard color='red' icon='remove' text='Incorrect' count={props.IncorrectCount} />
        <StatCard color='black' icon='bar chart' text='Grade' count={Math.round((props.CorrectCount / props.TotalCount) * 100) + "%"} />
    </Segment>
)

export default GameScore;
